/* TODO: replace this code with mockup code

See `resolveIcon` function in mockup/src/core/utils.js
*/
import fetch from 'isomorphic-fetch';
import { url } from '@ts/utils/url';

export class IconService {
  constructor(private readonly portalUrl: string = url.getPortalUrl()) {}

  /**
   * Gets Icon SVG from registered icons in icons.xml
   * @param iconName - icon name according to registered name
   * @returns - the SVG html element for the requested icon
   */
  getRegisteredIcon = async (iconName: string) => {
    const url = `${this.portalUrl}/@@iconresolver/${iconName}`;

    const settings: RequestInit = {
      method: 'GET',
    };

    const response = await fetch(url, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const svgString = await response.text();

    return svgString;
  };
}
